<i18n>
{
  "en": {
    "xrobotmon": "XRobotmon"
  },
  "zhHant": {
    "xrobotmon": "XRobotmon"
  },
  "ja": {
    "xrobotmon": "Xロボットモン"
  },
  "ko": {
    "xrobotmon": "XRobotmon"
  }
}
</i18n>
<template>
  <span>
    {{ $t('xrobotmon') }}
  </span>
</template>

<script>
export default {
  name: 'XRobotmonTitle',
};
</script>